module.exports = __webpack_public_path__ + "img/dpzkzn.36544a41.png";